import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    cashSaleStatus: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      gap: 5
    },
    cashSaleStatusSuccess: {
      color: theme.palette.success.main,
      "& .MuiTypography-root": {
        color: theme.palette.success.main
      }
    },
    cashSaleStatusFailed: {
      color: theme.palette.error.light,
      "& .MuiTypography-root": {
        color: theme.palette.error.light
      }
    }
  }),
  { name: "CashSaleStatus" }
);

export default useStyles;
